import { Component, OnInit, AfterViewInit, OnDestroy, Input } from '@angular/core';
import Swal from 'sweetalert2';
import * as Highcharts from 'highcharts';
import { HighchartsOptions } from 'src/app/config/highcharts-config';
import { saveAs } from 'file-saver';
import { StihlCampaignOrderCrmDTO } from 'src/app/models/stihl-campaign-dto';
import { CampaignOrderService } from 'src/app/services/campaign-order.service';
import { heightContentAnimation } from 'src/app/animations';

declare var $: any;

@Component({
  selector: 'statistics-crm',
  templateUrl: './statistics-crm.component.html',
  animations: [heightContentAnimation]
})

export class StatisticsCrmComponent implements OnInit {
  @Input() idOrder: string;
  @Input() showContacts: boolean;
  totalMailsSent: any;
  totalEntregados: any;
  totalAbiertos: any;
  totalBajas: any;
  totalErrores: any;
  totalClickeados: any;
  distinctClicks: any;
  model: StihlCampaignOrderCrmDTO;
  downloading = false;
  devices: any[];

  constructor(
    private orderService: CampaignOrderService
  ) {
  }

  ngOnInit() {
    this.getOrder();
  }

  getDashboardData() {
    this.getDataChartSendMail();
    if (this.model.IdSendType == 2) {
      this.getDataChartMailsOpened();
      this.getDataChartMailsClick();
    }
  }

  public optionChartSendMail: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: {point.percentage:.1f}%'
    },
    credits: {
      enabled: false
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'black'
          },
          format: '{point.name}: {point.percentage:.1f} %'
        }
      }
    },
    series: [{
      type: 'pie',
      name: 'Enviados',
      colorByPoint: true,
      innerSize: '50%',
      data: []
    }]
  }

  public optionChartMailsOpened: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: {point.percentage:.1f}%'
    },
    credits: {
      enabled: false
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'black'
          },
          format: '{point.name}: {point.percentage:.1f} %'
        }
      }
    },
    series: [{
      type: 'pie',
      name: 'Abiertos',
      colorByPoint: true,
      innerSize: '50%',
      data: []
    }]
  }

  public optionChartMailsClick: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: {point.percentage:.1f}%'
    },
    credits: {
      enabled: false
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'black'
          },
          format: '{point.name}: {point.percentage:.1f} %'
        }
      }
    },
    series: [{
      type: 'pie',
      name: 'Clickeados',
      colorByPoint: true,
      innerSize: '50%',
      data: []
    }]
  }


  getDataChartSendMail() {
    this.orderService.getDataChartSendMail(this.idOrder).subscribe(resp => {
      this.totalMailsSent = resp[0];
      this.totalEntregados = resp[1];
      this.totalBajas = resp[4];
      this.totalErrores = resp[5];
      var optionCharSendMail = this.optionChartSendMail;
      optionCharSendMail.series[0].data.push(resp[2]);
      optionCharSendMail.series[0].data.push(resp[3]);
      Highcharts.setOptions(HighchartsOptions.highcharts_options);
      Highcharts.chart('MailsSend', optionCharSendMail);

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocorreu um erro ao recuperar os dados'
      });
    });
  }

  getDataChartMailsOpened() {
    this.orderService.getDataChartMailsOpened(this.idOrder).subscribe(resp => {
      this.totalAbiertos = resp[0];
      var optionChartMailsOpened = this.optionChartMailsOpened;
      optionChartMailsOpened.series[0].data.push(resp[1]);
      optionChartMailsOpened.series[0].data.push(resp[2]);
      Highcharts.setOptions(HighchartsOptions.highcharts_options);
      Highcharts.chart('MailsOpened', optionChartMailsOpened);

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocorreu um erro ao recuperar os dados'
      });
    });
  }

  getDataChartMailsClick() {
    this.orderService.getDataChartMailsClick(this.idOrder).subscribe(resp => {
      this.totalClickeados = resp[0];
      this.distinctClicks = resp[3];
      var optionChartMailsClick = this.optionChartMailsClick;
      optionChartMailsClick.series[0].data.push(resp[1]);
      optionChartMailsClick.series[0].data.push(resp[2]);
      Highcharts.setOptions(HighchartsOptions.highcharts_options);
      Highcharts.chart('MailsClick', optionChartMailsClick);
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocorreu um erro ao recuperar os dados'
      });
    });
  }

  getOrder() {
    this.orderService.getOrderCrmById(this.idOrder).subscribe(resp => {
      this.model = resp;
      this.getDashboardData();
      this.getDevices();
    });
  }

  getDevices() {
    this.orderService.getStatisticsCrmDevice(this.idOrder).subscribe(resp => {
      this.devices = resp;
    });
  }

  Downloadexcel() {
    this.downloading = true;
    this.orderService.getStatisticsCrmExcel(this.idOrder).subscribe(resp => {
      saveAs(resp, "Relatório-de-uso-CRM.xlsx");
      this.downloading = false;
    });
  }

}
